import React from 'react';

export const getPriceBlock = (amount: number) => {
  const price = amount / 100;
  const splitPrice = price.toFixed(2).split('.');
  return <>$<span>{splitPrice[0]}</span>.{splitPrice[1]}</>
}

export const preparePriceBlock = ({amount, prevAmount}: {
  amount?: number;
  prevAmount?: number;
} = {}) => {
  if (!amount) {
    return <span>N/A</span>
  }
  if (prevAmount && prevAmount < amount) {
    return <><span>+</span>{getPriceBlock(amount - prevAmount)}</>
  }
  return <>{getPriceBlock(amount)}</>
}
